import React, { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from 'react-hook-form';
import authenticationServices from '../../../services/authentication-services';
import Button from '../../../shared/components/atoms/button/button';
import Input from '../../../shared/components/atoms/input/input';
import * as reCaptchaKey from "../../../shared/constants/reCaptcha";
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import transversalServices from '../../../shared/services/transversal-services';
import useHaveClubPeque from '../../../shared/hooks/useHaveClubPeque'
import { sessionStorage, localStorage } from '../../../shared/utils/storage';
import './login.scss';

const Login = ({ setActiveToast, openModal }) => {

    const { register, setValue, handleSubmit, getValues, formState: { errors } } = useForm();
    const { homeLink } = useHomeLinkMode();
    const [loading, setLoading] = useState(false)
    const fromMagazine = getParameterByName('fromMagazine')
    const {haveClubPeque} = useHaveClubPeque()
    const isEC = process.env.LOCALE === ("es-EC")

    const [type, setType] = React.useState("password")
    const [wrongPassword, setWrongPassword] = useState(false);

    const recaptchaRef = useRef(null)

    useEffect(() => {
        sessionStorage.removeItem("TOKEN_INFO")
        recaptchaRef.current.execute()
    }, []);


    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        let url_string = typeof window !== 'undefined' ? window.location.href : '/';
        let regex = new RegExp("[\\?&]" + name + "=([^?&#/]*)"),
            results = regex.exec(url_string);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    const onSubmit = (data) => {

        setLoading(true)
        setWrongPassword(false)
        const payload = {
            captcha: recaptchaRef.current.getValue(),
            // captcha: null,
            emailOrPhone: data.email,
            indicative: process.env.COUNTRY_PHONE_PREFIX,
            password: data.password
        }
        authenticationServices.authentication(payload).then(
            response => {

                if (response.status === 200) {
                    recaptchaRef.current.execute()

                    let config = {
                        headers: {
                            Authorization: response.data.tokenData.idToken,
                        },
                    }
                    transversalServices.getInfoUser(config).then(
                        res => {
                            setLoading(false)
                            if (res.status === 200) {
                                if (res.data.forceKey) {
                                    openModal(payload.password, response.data.tokenData)
                                } else {
                                    localStorage.setItem("TOKEN_INFO", JSON.stringify(response.data.tokenData));
                                    if (sessionStorage.getItem("PREVIOUS_PAGE") !== null) {
                                        window.location.href = sessionStorage.getItem("PREVIOUS_PAGE")
                                    } else {
                                        window.location.href = homeLink
                                    }
                                }

                            } else {
                                recaptchaRef.current.execute()
                                setActiveToast({
                                    messageToast: res.userMessage,
                                    checkToast: false
                                })
                            }

                        }
                    )
                } else {
                    setLoading(false)
                    recaptchaRef.current.execute()
                    if (response.status === 400) {
                        recaptchaRef.current.execute()
                        if (response.errorCode === "DEM071") {
                            setWrongPassword(true)
                        } else {
                            setActiveToast({
                                messageToast: response.userMessage,
                                checkToast: false
                            })
                        }
                    } else {
                        setActiveToast({
                            messageToast: response.userMessage,
                            checkToast: false
                        })
                    }
                }
            }
        )
    }

    const inputFocus = () => {
        let password = document.getElementById("password")
        let passwordLabel = document.getElementById("password-label")

        password.classList.add("__focused")
        passwordLabel.classList.add("__visible")
    }

    const inputFocusOut = () => {
        let password = document.getElementById("password")
        let passwordLabel = document.getElementById("password-label")

        password.classList.remove("__focused")
        passwordLabel.classList.remove("__visible")
    }

    return (
        <div className="f-m-login">
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={reCaptchaKey.key}
            />
            <form className="f-m-login__form" onSubmit={handleSubmit((e) => onSubmit(e))}>
                <div className="f-m-login__content">
                    <div className={"f-m-login__title " + (fromMagazine ? "__left" : "")}>
                        <h2 >{fromMagazine ? "Para guardar tus artículos favoritos debes estar registrado en el Club Pequeñín." : haveClubPeque ? "¿Ya haces parte del Club Pequeñín?" : isEC ? "¿Ya estás registrado?" : "¿Ya haces parte de la comunidad Pequeñin?"}</h2>
                    </div>
                    <div className="f-m-login__fields-container">
                        <div className="f-m-login__field">
                            <Input
                                label="Ingresa tu correo"
                                name="email"
                                maxLength="50"
                                type="email"
                                placeholder="Ingresa tu correo"
                                register={register}
                                validationRules={
                                    {
                                        required:
                                        {
                                            value: true,
                                            message: '*Debe ingresar un correo electrónico'
                                        },
                                        pattern:
                                        {
                                            value: /^(([^<>()[\]\\.,;:=\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            message: '*No se permiten caracteres especiales'
                                        },
                                        maxLength: {
                                            value: 50,
                                            message: '*El correo no debe superar los 50 dígitos'
                                        },
                                        minLength: {
                                            value: 4,
                                            message: '*El correo debe tener al menos 4 caracteres'
                                        }
                                    }
                                }
                                setValue={setValue}
                                error={errors ? errors.email : ""}
                            />
                        </div>
                        <div className="f-m-login__field">
                            <div
                                className="f-m-login__eye-icon"
                                onClick={() => {
                                    if (type === "password") {
                                        setType("text")
                                    } else {
                                        setType("password")
                                    }
                                }}
                            >
                            </div>
                            <div className="f-m-login__password">
                                <label id="password-label" htmlFor="password" className="f-m-login__password-label">Ingresa tu contraseña</label>
                                <div id="password" className={"f-m-login__password-box " + (((errors.password) || wrongPassword) ? "__error" : "")} >
                                    <input
                                        name="password"
                                        maxLength="50"
                                        placeholder="Ingresa tu contraseña"
                                        type={type}
                                        {...register('password', {
                                            required:
                                            {
                                                value: true,
                                                message: '*Debe ingresar una contraseña'
                                            },
                                            minLength: {
                                                value: 2,
                                                message: '*La contraseña debe ser de mínimo 2 caracteres'
                                            }
                                        })}

                                        onFocus={() => inputFocus()}
                                        onBlur={() => {
                                            inputFocusOut()
                                        }}

                                    />
                                </div>
                                <div className="f-m-login__password-messages">
                                    <div className="f-m-login__password-errors">
                                        {errors.password &&
                                            <span className="f-m-login__error">{errors.password.message}</span>
                                        }
                                        {wrongPassword &&
                                            <span className="f-m-login__error">*Contraseña incorrecta</span>
                                        }
                                    </div>
                                    <div className="f-m-login__forgotten-password">
                                        <a
                                            onClick={() => {
                                                location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "autenticacion/") + "recuperar-contrasena"
                                            }}
                                        // href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "autenticacion/") + "recuperar-contrasena"}
                                        >¿Olvidaste tu contraseña?</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Button
                    id="f-a-button__login"
                    type="submit"
                    className="f-a-button__primary-purple f-a-button__extra-big f-m-login__button"
                    copy={"Iniciar sesión"}
                    loader={loading}
                />
            </form>
        </div>
    )
}

export default Login
